import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { getBookingPrintTicketApi, getMultiPrintInfoBookingApi } from '../../../api/booking';
import { BookingState, PrintBookingInfoParams } from '../../../types/booking';
import { RootState } from '../../store';
import PrintMultiBookingModal from '../../../pages/bookings/printMultiBooking/PrintMultiBookingModal';

export const printTicket = createAsyncThunk(
  'admin/booking/print-ticket',
  async (params: any, { dispatch, rejectWithValue }) => {
    try {
      const response = await getBookingPrintTicketApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setUpdate({ status: status, data: data }));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(setUpdateError(response));
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const getPrintInfoBooking = createAsyncThunk(
  'admin/booking/getPrintInfoBooking',
  async (params: PrintBookingInfoParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await getMultiPrintInfoBookingApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setDataPrintBooking({ status: status, data: data }));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(setUpdateError(response));
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const printTicketSlice = createSlice({
  name: 'printTicket',
  initialState: {
    error: false,
    loading: false,
    success: false,
    status: 0,
    statusPrintInfo: 0,
    message: '',
    errorDetail: null,
    isPrintTicket: false,
    dataPrintTicket: [],
  } as BookingState,
  reducers: {
    setUpdate: (state: BookingState, { payload }) => {
      const { message } = payload.data;
      state.status = payload?.status;
      state.message = message;
    },
    setDataPrintBooking: (state: BookingState, { payload }) => {
      state.dataPrintTicket = payload?.data?.data;
      state.statusPrintInfo = payload?.status;
    },
    setUpdateError: (state: BookingState, { payload }) => {
      const { errors } = payload.data;
      state.status = payload?.status;
      state.errorDetail = errors;
    },
    setIsPrintTicket: (state: BookingState, { payload }) => {
      state.isPrintTicket = payload;
    },
    resetPrintTicket: (state: BookingState) => {
      state.success = false;
      state.message = '';
      state.errorDetail = null;
      state.status = 0;
      state.isPrintTicket = false;
    },
    resetPrintMultiTicket: (state: BookingState) => {
      state.statusPrintInfo = 0;
      state.dataPrintTicket = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(printTicket.pending, (state: BookingState) => {
      state.loading = true;
      state.success = false;
    });
    builder.addCase(printTicket.fulfilled, (state: BookingState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(printTicket.rejected, (state: BookingState, { payload }) => {
      state.loading = false;
      state.success = false;
      state.error = true;
      state.message = payload;
    });
    builder.addCase(getPrintInfoBooking.pending, (state: BookingState) => {
      state.loading = true;
    });
    builder.addCase(getPrintInfoBooking.fulfilled, (state: BookingState) => {
      state.loading = false;
    });
    builder.addCase(getPrintInfoBooking.rejected, (state: BookingState, { payload }) => {
      state.loading = false;
    });
  },
});

export const printTicketSelector = (state: RootState) => state.printTicket;
export const { setUpdateError, setUpdate, resetPrintTicket, setIsPrintTicket, setDataPrintBooking,resetPrintMultiTicket } =
  printTicketSlice.actions;
